// extracted by mini-css-extract-plugin
export default {"palletsPricingInnerContainer":"RatesConfigurationForm_palletsPricingInnerContainer__ag0Po"};